// SPDX-License-Identifier: AGPL-3.0-or-later

/** randomUUID requires a secure context; getRandomValues also works in HTTP previews. */
export function generateUuid(): string {
	if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
	const bytes = crypto.getRandomValues(new Uint8Array(16));
	bytes[6] = (bytes[6]! & 0x0f) | 0x40;
	bytes[8] = (bytes[8]! & 0x3f) | 0x80;
	return Array.from(
		bytes,
		(byte, index) => `${[4, 6, 8, 10].includes(index) ? '-' : ''}${byte.toString(16).padStart(2, '0')}`,
	).join('');
}
